<template>
  <svg viewBox="0 0 8 13" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.41 11.09L2.83 6.5L7.41 1.91L6 0.5L0 6.5L6 12.5L7.41 11.09Z"
    />
  </svg>
</template>

<script>

export default {
  name: 'KIconKeyboardArrowLeft'
}
</script>
